import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ObjectActionCreators from '../../../actions';

const DataColumnResizer = ({ panelNumber, colNumber }) => {
  const resizerRef = useRef(null);
  const dispatch = useDispatch();

  const handleMouseDown = (e) => {
    e.stopPropagation();
    e.preventDefault();
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    // Check if the left mouse button is pressed (buttons === 1 indicates the left button)
    if (e.buttons !== 1) {
      handleMouseUp(); // If the left button is not pressed, simulate mouse up
      return;
    }

    e.stopPropagation();
    const newWidth =
      e.clientX - resizerRef.current.parentElement.getBoundingClientRect().left;
    dispatch(
      ObjectActionCreators.updateDataColumSize(panelNumber, colNumber, newWidth)
    );
  };

  const handleMouseUp = () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  // Clean up any listeners on component unmount
  useEffect(() => {
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div
      ref={resizerRef}
      className="resizer"
      onMouseDown={handleMouseDown}
      draggable="false"
      style={{
        width: '33px', // zone cliquable
        backgroundColor: 'transparent', // zone transparente
        position: 'relative',
        cursor: 'col-resize',
        height: '100%',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '1px', // vraie ligne
          backgroundColor: 'var(--ds-border-base)',
          height: '100%',
        }}
      ></div>
    </div>
  );
};

export default DataColumnResizer;
